import { CommitmentsScenariosVariantsService_commitmentScenarioVariantVersionServiceGetSimulateVariant } from '@festina/life-general-types/life/hooks/CommitmentsScenariosVariantsService_commitmentScenarioVariantVersionServiceGetSimulateVariant'

export const useFetchScenarioVariantSimulation =
  CommitmentsScenariosVariantsService_commitmentScenarioVariantVersionServiceGetSimulateVariant.useSuspenseQuery
